import React from 'react';
import Question from '../components/Question';
import QuestionCount from '../components/QuestionCount';
import AnswerOption from '../components/AnswerOption';
import {QuizProps} from '../components/types';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import ProgressBar from 'react-bootstrap/ProgressBar';
import Button from 'react-bootstrap/Button';
import {Link} from "react-router-dom";
import Loading from "./Loading";

const meaningMap = new Map(Object.entries({
    "1": 'I strongly disagree',
    "2": 'I disagree',
    "3": 'I am neutral',
    "4": 'I agree',
    "5": 'I strongly agree'
}));

function Quiz(props: QuizProps) {

    function renderAnswerOptions(answer: string) {
        const meaning = meaningMap.get(answer) as string
        const key = props.questionId + "-" + answer
        return (
            <AnswerOption
                key={key}
                answer={answer}
                meaning={meaning}
                selected={props.answer === answer}
                questionId={props.questionId}
                onAnswerSelected={props.onAnswerSelected}
            />
        );
    }
    if (props.counter === props.questionTotal){
        return (
          <div>
              <br />
              Thank you. please wait while we compute your results.
              A link to an assessment report will appear below shortly<br /> <br />
              {props.reportLink? <Link to={props.reportLink}> Results </Link> : <Loading/>}
          </div>
        );
    }

    return (
        <div className="quiz" key={props.questionId}>
            <ProgressBar striped variant="success" now={100 * props.counter / props.questionTotal}/>

            <ReactCSSTransitionGroup
                className="container"
                component="div"
                transitionName="fade"
                transitionEnterTimeout={800}
                transitionLeaveTimeout={500}
                transitionAppear
                transitionAppearTimeout={500}
            >

       <span>
         <Button variant="outline-secondary" size="sm" onClick={props.onBack} disabled={props.counter === props.questionTotal}>back</Button>

         <QuestionCount
             counter={props.counter}
             total={props.questionTotal}
         />
         </span>
                <Question content={props.question}/>
            </ReactCSSTransitionGroup>

            <ul className="answerOptions">
                {props.answerOptions.map(renderAnswerOptions)}
            </ul>
        </div>

    );
}

export default Quiz;